import AppointmentsInfo from "./AppointmentsInfo";
import AppointmentsInfoDetails from "./AppointmentsInfoDetails";
import ServiceInfoList from "./ServiceInfoList";
export {AppointmentsInfo, AppointmentsInfoDetails, ServiceInfoList}